"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get PREFIX_APIV3_DATA () {
        return PREFIX_APIV3_DATA;
    },
    get PREFIX_APIV3_METABASE () {
        return PREFIX_APIV3_METABASE;
    }
});
const PREFIX_APIV3_DATA = '/api/v3/data/:baseName';
const PREFIX_APIV3_METABASE = '/api/v3/meta/bases/:baseId';
